import * as React from 'react';
import styled from 'styled-components';
import * as Icon from '../../../icons';
import * as S from '../';
import { slot, useGetter, useEffect } from '../slots';
import { splitClasses } from '../../utils';
import { ctxSelectClass } from '../shared';


type Value = Record<string, any>;

export type TSimpleSelect = {
    type: 'simple',
    name: string,
    onSelect: (x: unknown, name: string) => void,
    value?: Value | null,
    data: Value[],
    onClear?: (name: string) => void,
    disabled?: boolean,
    placeholder?: string,
}

const Component = React.forwardRef<HTMLInputElement, TSimpleSelect>(({
    name,
    onSelect,
    value = null,
    data,
    onClear,
    placeholder,
    disabled,
}) => {
    return (
        <S.Select 
            name={name}
            onSelect={onSelect}
            onClear={onClear}>
            <S.Control disabled={disabled}>
                <S.SimpleControl value={value}>
                    {(x) => x ? x.text : placeholder}
                </S.SimpleControl>
            </S.Control>
            <SimpleIndicator />
            <S.Dropdown maxHeight={250}>
                <S.List data={data}>
                    <S.Item>{(x) => <span>{x.text}</span>}</S.Item>
                    <S.Error>Данных нет.</S.Error>
                </S.List>
            </S.Dropdown>
            <S.Cursor />
            <S.Keyboard />
        </S.Select>
    );
});

const SimpleIndicator = slot('indicator')(({ className }) => {

    const dropdownController = useGetter('dropdown');
    const targetController =   useGetter('target');

    const [dropdownOpened] =   useEffect('dropdownOpened');
    const [dropdownClosed] =   useEffect('dropdownClosed');
    const [changeTarget] =     useEffect('changeTarget');
    const [changeValue] =      useEffect('changeValue');

    const variants = {
        default: {
            icon: (
                <IconWrapper>
                    <SelectIcon />
                </IconWrapper>
            ),
            handler: () => {
                dropdownController.open();
                targetController.active();
            },
        },
        openedEmpty: {
            icon: (
                <IconWrapper style={{ transform: 'rotate(90deg)' }}>
                    <SelectIcon />
                </IconWrapper>
            ),
            handler: () => {
                dropdownController.close();
            },
        },
    }

    const { icon, handler } = React.useMemo(() => {
        const dropdownIsOpen = dropdownController.isOpen();
        
        if(dropdownIsOpen){
            return variants.openedEmpty;
        }
        else {
            return variants.default;
        }
    }, [dropdownOpened, changeTarget, dropdownClosed, changeValue]);


    return (
        <SelectButton 
            className={splitClasses(ctxSelectClass('indicator'), className)}
            onMouseDown={handler}>
            {icon}
        </SelectButton>
    );
});

export const SelectButton = styled.button`
    position: relative;
    background: transparent;
    line-height: 0;
    /* padding: .5em 1em; */
    transition: all .33s ease;
    transform-origin: 50% 50%;
    width: 34px;
`;


const IconWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CloseWrapper = styled.div`
`;

export const Close = styled.button`
    background-color: #9C99B8;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    line-height: 0;
    position: relative;
    border: 0;

    &:hover {
        background-color: #7F7B9B;
    }

    & > svg {
        fill: #fbfbfd;
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(100% - 8px);
        height: calc(100% - 8px);
        transform: translate(-50%, -50%);
    }
`;

const SelectIcon = styled(Icon.Select)`
    width: 7px;
    height: 9px;
    margin: auto;
`;

export default Component;
